var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AchievementService } from './../../../shared/services/achievement.service';
import * as moment from 'moment-timezone';
import { MatDialogRef, MatDialog, MatSnackBar, MatTableDataSource } from '@angular/material';
import { Program } from 'app/shared/models/Program';
import { VideoPlayerComponent } from 'app/theme/components/video-player/video-player.component';
import { AddDialogComponent } from '../add-dialog/add-dialog.component';
import { StatisticService } from '../../../shared/services/statistic.service';
import { Stat } from '../../../shared/models/Stat';
import { TranslateService } from '@ngx-translate/core';
import { ChallengeService } from 'app/shared/services/challenge.service';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { Subject } from 'rxjs';
import { SuccessDialogComponent } from '../achievement/components/success-dialog/success-dialog.component';
import { UserService } from 'app/shared/services/user.service';
var VideoDialogComponent = (function () {
    function VideoDialogComponent(dialogRef, data, stats, snackBar, translate, dialog, challengeService, achievementService, userService) {
        var _this = this;
        this.dialogRef = dialogRef;
        this.data = data;
        this.stats = stats;
        this.snackBar = snackBar;
        this.translate = translate;
        this.dialog = dialog;
        this.challengeService = challengeService;
        this.achievementService = achievementService;
        this.userService = userService;
        this.isSingleVideo = false;
        this.currentExerciseIndex = 0;
        this.canGoBack = false;
        this.allExerciseSize = 0;
        this.nextExerciseCalled = false;
        this.didSentStatistic = false;
        this.ngUnsubscribe = new Subject();
        this.takesPartInTeamChallenge = false;
        this.achievementsProcessing = false;
        // check if achievments are activated for company
        this.isAchievementsActivated = false;
        this.ELEMENT_DATA = [
            { position: 0, alias: '...', points: 0, isRequester: false },
            { position: 1, alias: '...', points: 0, isRequester: false },
            { position: 2, alias: '...', points: 0, isRequester: false },
            { position: 3, alias: '...', points: 0, isRequester: false },
            { position: 4, alias: '...', points: 0, isRequester: false },
            { position: 5, alias: '...', points: 0, isRequester: false },
        ];
        this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
        this.buttonClicked = false;
        if (data.program) {
            this.program = data.program;
        }
        else if (data.exercise) {
            var ex = data.exercise;
            this.program = new Program();
            this.program.exercises = [ex];
            this.program.exerciseIds = [ex._id];
            this.program.title = ex.title['de'];
            this.isSingleVideo = true;
            this.nextExerciseCalled = false;
        }
        this.getCompanyData();
        this.canGoBack = data.canGoBack;
        this.allExerciseSize = data.sizeAllExercise;
        // Find out whether toast for scored points should be displayed
        combineLatest(this.challengeService.displayedChallenge, this.challengeService.team, this.challengeService.teamUser)
            .takeUntil(this.ngUnsubscribe)
            .subscribe(function (_a) {
            var challenge = _a[0], team = _a[1], user = _a[2];
            if (
            // If a challenge is currently running and the user is member of a team and the team has enough members for the challenge
            challenge &&
                moment(challenge.start).isBefore(moment()) &&
                moment(challenge.end).isAfter(moment()) &&
                user &&
                user.membershipStatus === 'member' &&
                team &&
                team.userGroups.members.length >= challenge.minimalTeamMembers) {
                _this.takesPartInTeamChallenge = true;
            }
            else {
                _this.takesPartInTeamChallenge = false;
            }
        });
    }
    VideoDialogComponent.prototype.getCompanyData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var companyData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.userService.getCompany()];
                    case 1:
                        companyData = _a.sent();
                        this.isAchievementsActivated = companyData.activateAchievements;
                        return [2 /*return*/];
                }
            });
        });
    };
    VideoDialogComponent.prototype.skipTo = function (exercise) {
        this.currentExerciseIndex = this.program.exercises.indexOf(exercise);
        this.videoPlayer.changeUrl(this.program.exercises[this.currentExerciseIndex].videoUrl['de'], this.program.exercises[this.currentExerciseIndex].captionUrl[this.translate.currentLang]);
        this.didSentStatistic = false;
    };
    VideoDialogComponent.prototype.videoProgress = function (event) {
        if (event.value > 15 && !this.didSentStatistic) {
            this.didSentStatistic = true;
            this.stats.sendDidPlayVideoStatistic(new Stat(this.program.exerciseIds[this.currentExerciseIndex], this.program.contextID));
        }
    };
    VideoDialogComponent.prototype.countUnique = function (iterable) {
        return new Set(iterable).size;
    };
    VideoDialogComponent.prototype.videoEnded = function (e) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var newUnlockedAchievements, heroAchievement, newArray;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.isAchievementsActivated && !this.achievementsProcessing)) return [3 /*break*/, 3];
                        this.achievementsProcessing = true;
                        return [4 /*yield*/, this.achievementService.processAchievementData(this.program, this.allExerciseSize, this.nextExerciseCalled, this.currentExerciseIndex)];
                    case 1:
                        newUnlockedAchievements = _a.sent();
                        return [4 /*yield*/, this.achievementService.checkB2ActionHeroAchievement()];
                    case 2:
                        heroAchievement = _a.sent();
                        if (Object.keys(heroAchievement).length > 0) {
                            newUnlockedAchievements.push(heroAchievement);
                        }
                        newArray = newUnlockedAchievements.filter(function (value) { return Object.keys(value).length !== 0; });
                        if (newArray.length > 0) {
                            this.openSuccessDialog(newArray[0]);
                        }
                        this.achievementsProcessing = false;
                        _a.label = 3;
                    case 3:
                        this.stats.getMyStatistic().then(function (stats) {
                            if (!_this.takesPartInTeamChallenge && stats[0] <= 6) {
                                _this.translate.get('PLAYER.ALERT.scoredPoints', { some: stats[0], all: 6 }).subscribe(function (message) {
                                    _this.snackBar.open(message, null, {
                                        verticalPosition: 'top',
                                        duration: 4000,
                                        panelClass: ['b2a-success', 'top'],
                                    });
                                });
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    VideoDialogComponent.prototype.getNextExercise = function () {
        if (this.program.exercises.length > this.currentExerciseIndex + 1) {
            this.currentExerciseIndex += 1;
            this.nextExerciseCalled = true;
            this.videoPlayer.changeUrl(this.program.exercises[this.currentExerciseIndex].videoUrl['de'], this.program.exercises[this.currentExerciseIndex].captionUrl[this.translate.currentLang]);
        }
        else {
            this.closeDialog();
        }
        this.didSentStatistic = false;
    };
    VideoDialogComponent.prototype.getNewExercise = function () {
        this.closeDialog({ newRandom: true });
    };
    VideoDialogComponent.prototype.onNoClick = function () {
        this.dialogRef.close();
    };
    VideoDialogComponent.prototype.closeDialog = function (result) {
        this.dialogRef.close(result);
    };
    VideoDialogComponent.prototype.openAddDialog = function (event) {
        if (this.videoPlayer && this.videoPlayer.fullScreened) {
            this.videoPlayer.toggleFullScreen();
        }
        event.stopPropagation();
        var dialogRef = this.dialog.open(AddDialogComponent, {
            width: '90vw',
            height: '400px',
            data: { exerciseID: this.program.exercises[this.currentExerciseIndex] },
        });
    };
    VideoDialogComponent.prototype.openSuccessDialog = function (achievement) {
        if (this.videoPlayer && this.videoPlayer.fullScreened) {
            this.videoPlayer.toggleFullScreen();
        }
        console.log('Success Dialog opened');
        var dialogRef = this.dialog.open(SuccessDialogComponent, {
            width: '400px',
            height: '400px',
            data: { achievement: achievement },
        });
        this.closeDialog();
    };
    /**
     * On destroy cancel active subscriptions
     */
    VideoDialogComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    return VideoDialogComponent;
}());
export { VideoDialogComponent };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/videoDialog/videoDialog.component.ts.pre-build-optimizer.js